import { useEffect, useState } from 'react';

const URL = 'https://api.open-meteo.com/v1/forecast?latitude=35.4676&longitude=-97.5164&current=temperature_2m,weather_code,wind_speed_10m&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_probability_max&temperature_unit=fahrenheit&wind_speed_unit=mph&timezone=America%2FChicago&forecast_days=2';

export const RAIN_ALERT_THRESHOLD = 60;

export const useOkcWeather = () => {
  const [state, setState] = useState({ data: null, failed: false });
  useEffect(() => {
    fetch(URL)
      .then((r) => r.json())
      .then((data) => setState({ data, failed: false }))
      .catch(() => setState({ data: null, failed: true }));
  }, []);
  return state;
};

export const rainChance = (data) => data?.daily?.precipitation_probability_max?.[0] ?? 0;
